const choices = {
    ongoing: 'en cours',
    waiting: 'en attente',
    toCallBack: 'à rappeler',
    offTarget: 'hors cible',
    noContinuation: 'sans suite',
};

export default choices;
